/**
 * SDS History module — ported from Designer
 * Responsible for undo/redo operations
 */

import { store } from '../../../core/store.js'
import { createLogger } from '../../../utils/logger.js'


const log = createLogger('sds-history')

export function undo() {
  const sdk = store.getState('design.sdkInstance')
  if (!sdk || !sdk.sarto) return

  try {
    sdk.sarto.undo()
    log.info('Undo')
  } catch (error) {
    log.warn('Failed to undo:', error)
  }
}

export function redo() {
  const sdk = store.getState('design.sdkInstance')
  if (!sdk || !sdk.sarto) return

  try {
    sdk.sarto.redo()
    log.info('Redo')
  } catch (error) {
    log.warn('Failed to redo:', error)
  }
}

export default { undo, redo }
